import { render } from "./MySchedule.vue?vue&type=template&id=ef81acf2&scoped=true"
import script from "./MySchedule.vue?vue&type=script&lang=js"
export * from "./MySchedule.vue?vue&type=script&lang=js"

import "./MySchedule.vue?vue&type=style&index=0&id=ef81acf2&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Tegra\\abrafarma\\abrafarma-app-ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef81acf2"]])

export default __exports__